'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _NavigationBarControl = require('../../../lib/ui/NavigationBarControl');

var _NavigationBarControl2 = _interopRequireDefault(_NavigationBarControl);

var _IndexControl = require('../../../lib/ui/IndexControl');

var _IndexControl2 = _interopRequireDefault(_IndexControl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SelectLocation = function SelectLocation(element, args) {
  var _this = this;

  _classCallCheck(this, SelectLocation);

  var fragment = document.createDocumentFragment();
  new _NavigationBarControl2.default(fragment, {
    title: 'Kies vestiging',
    leftHandButtons: [{
      onclick: args.oncancel,
      icon: '\uE00D'
    }, {
      onclick: args.onok,
      icon: '\uE03D',
      label: 'Geen selectie'
    }]
  });

  window.PRIM.dataAccess.resolve('locations', null, true).then(function (items) {
    _this.results.setItems(items);
  });

  var div = document.createElement('div');
  div.className = 'viewport';

  this.results = new _IndexControl2.default(div, { items: [], onclick: args.onok });
  fragment.appendChild(div);

  element.appendChild(fragment);
};

exports.default = SelectLocation;


//////////////////
// WEBPACK FOOTER
// ./js/modules/location/action/SelectLocation.js
// module id = 56
// module chunks = 0